"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ConcernFormContainer = void 0;
var _Summary = require("../../components/Summary");
var _concernFormContext = require("../../contexts/concernFormContext");
var _ConcernForm = require("../ConcernForm/ConcernForm");
var _jsxRuntime = require("react/jsx-runtime");
const ConcernFormContainer = ()=>{
    const { editable } = (0, _concernFormContext.useConcernForm)();
    if (!editable) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Summary.Summary, {});
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ConcernForm.ConcernForm, {});
};
exports.ConcernFormContainer = ConcernFormContainer;
